// ----------------------------------------------------------------------

import { alpha } from "@mui/material";

export default function MuiSwitch(theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          margin: 2,
          width: 44,
          height: 26,
          padding: 0,
          display: 'flex',
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            '&.Mui-checked': {
              transform: 'translateX(18px)',
              color: theme.palette.common.white,
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.SECONDARY,
                ...theme.applyStyles('dark', {
                  backgroundColor: '#177ddc',
                }),
              },
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 22,
            height: 22,
            borderRadius: 11,
          },
          '& .MuiSwitch-track': {
            borderRadius: 24 / 2,
            opacity: 1,
            backgroundColor: alpha('#000', 0.25),
            boxSizing: 'border-box',
            ...theme.applyStyles('dark', {
              backgroundColor: alpha('#fff', 0.35),
            }),
          },
        }
      }
    },
  };
}
